import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";

// ✅ Función helper para obtener headers frescos
const getHeaders = () => {
  const token = localStorage.getItem("authToken");
  return {
    Authorization: `${token}`,
  };
};

export const getIndicadoresByAsignaturaYPeriodo = async (
  asignaturaId,
  periodoId
) => {
  const response = await axios.get(
    `${API_BASE_URL}/indicadores/${asignaturaId}/${periodoId}`,
    { headers: getHeaders() }
  );
  return response.data;
};

export const getIndicadoresByPeriodoYSalon = async (periodoId, salonId) => {
  const response = await axios.get(
    `${API_BASE_URL}/indicadores/${periodoId}/${salonId}`,
    { headers: getHeaders() }
  );
  return response.data.data;
};

export const createIndicador = async (indicadorData) => {
  const response = await axios.post(
    `${API_BASE_URL}/indicadores`,
    indicadorData,
    { headers: getHeaders() }
  );
  return response.data;
};

export const updateIndicador = async (id, descripcion) => {
  const response = await axios.put(
    `${API_BASE_URL}/indicadores/${id}`,
    { descripcion },
    { headers: getHeaders() }
  );
  return response.data;
};

export const deleteIndicador = async (periodoId, salonId) => {
  const response = await axios.delete(`${API_BASE_URL}/indicadores/${periodoId}/${salonId}`, 
    {
    headers: getHeaders(),
  });
  return response.data;
};
